import type { Plugin } from 'vue';
import getBrandName from '@/helpers/getBrandName';

export default {
    install: (app) => {
        const brandName = getBrandName();
        app.provide('app-brand-name', brandName);
        document.getElementById('embed-assistent')?.classList.add(`branding--${brandName}`);
    },
} as unknown as Plugin;
